import React, {useState} from 'react';

import loadable from '@loadable/component';
import {Modal} from '@optimaxdev/design-system';

import {Greeting} from 'desktop/components/helpers/greeting/greeting';
import {SafeRender} from 'desktop/components/helpers/safeRender/safeRender';

import {useCheckLuxuryItem} from 'hooks/useCheckLuxuryItem/useCheckLuxuryItem';
import {flags} from 'libs/rollout';

import {Message} from '../message/message';
import {ReorderPopupSuccessPageConnected} from '../reorderPopupSuccessPage/reorderPopupSuccessPage';
import {SimplePayConnected} from '../simplePay/simplePay';

import s from './successPageContent.scss';

const OrderInfoInTYP = loadable(
    () => import(/* webpackChunkName: "Accessories" */ '../orderInfoInTYP/orderInfoInTYP'),
    {
        resolveComponent: components => components.OrderInfoInTYP,
    },
);

export type PropsTypeContentType = {
    isInsurance: boolean;
    message: string;
    orderId: string;
    hasAccessories: boolean;
    hasUpgrades: boolean;
    visiblePopup: boolean;
    closePopup: () => void;
    isSubscriptionItems: boolean;
};

/**
 * Content for TYP
 *
 * @param {PropsType} props - component props
 * @constructor
 */
export const SuccessPageContent: React.FC<PropsTypeContentType> = ({
    closePopup,
    hasUpgrades,
    isInsurance,
    isSubscriptionItems,
    message,
    orderId,
    visiblePopup,
}) => {
    const isLuxuryEnabled = useCheckLuxuryItem(flags.dLuxurySpecialExperience.isEnabled());
    const [isModalOpen, setModalOpen] = useState(false);

    return (
        <div className={s.wrapper}>
            <div className={s.container}>
                {Boolean(message) && <Message text={message} />}
                {isInsurance ? (
                    <>
                        <div className={s.greetingInsurance}>
                            <Greeting>Thank you for your order!</Greeting>
                        </div>
                        <p className={s.orderId}>You order number is: {orderId}</p>
                    </>
                ) : (
                    <SafeRender>
                        <OrderInfoInTYP hasUpgrades={hasUpgrades} />
                    </SafeRender>
                )}
            </div>
            {visiblePopup && (
                <Modal
                    isOpen={visiblePopup}
                    onRequestClose={closePopup}
                    overlay="dark"
                    overlayClassName={s.wrapPayment}
                >
                    <SimplePayConnected onClose={closePopup} />
                </Modal>
            )}
            {!isSubscriptionItems && !isLuxuryEnabled && (
                <ReorderPopupSuccessPageConnected isOpen={isModalOpen} setVisible={setModalOpen} />
            )}
        </div>
    );
};
